export const enum PaymentMethodsEnum {
  paymentMethod = "paymentMethod",
  paymentMethodsAvailable = "paymentMethodsAvailable",
  paymentPseUrl = "paymentPseUrl",
  preCreatePaymentMethod = "paymentMethods-PreCreate",
  paymentsAvailable = "paymentsAvailable",
  validateNequi = "validateNequi",
}

export const enum CreditsEnum {
  creditsAvailable = "creditsAvailable",
  referralCreditsAvailable = "referralCreditsAvailable",
  referralMoves = "referralMoves",
}

export const enum productsDetailsEnum {
  getProductQuestions = "getProductQuestions",
  getProductReviews = "getProductReviews",
  getProductInfiniteReviews = "getProductInfiniteReviews",
  getProductStatistics = "getProductStatistics",
  getProductNutritional = "getProductNutritional",
  getExclusiveDiscountProducts = "getExclusiveDiscountProducts",
}

export const enum CheckoutEnum {
  getCartAvailableProducts = "getCartAvailableProducts",
  getShippingInfo = "getShippingInfo",
  getQuickStart = "getQuickStart",
  getAvaliableStores = "getAvaliableStores",
}

export const enum MembershipEnum {
  listMemebership = "listMemebership",
}

export const enum SearchBarEnum {
  searchResults = "searchResults",
  searchSuggests = "searchSuggests",
}

export const enum AddressEnum {
  deleteAddress = "deleteAddress",
  getAddresses = "getAddresses",
}

export const enum OrdersEnum {
  getOrdersList = "getOrdersList",
  getOrderDetails = "getOrderDetails",
  getOrderDetailsV1 = "getOrderDetailsV1",
  getOrderProducts = "getOrderProducts",
  getOrderProductsSKU = "getOrderProductsSKU",
  orderCancel = "orderCancel",
  orderReview = "orderReview",
  orderRetryPayment = "orderRetryPayment",
  pendingOrders = "pendingOrders",
}

export const enum StoresEnum {
  getPickUpStores = "getPickUpStores",
}

export const enum IPEnum {
  ip = "ip",
}

export const enum Events {
  getEvents = "getEventsList",
}
